import React, { useEffect } from 'react';
                                                                                                                                                                                                                                                                                    import './programassociales.css';
                                                                                                                                                                                                                                                                                    import { programassociales } from '../../json/programassociales';

const SubsidioVerificacion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Subsidio al Servicio de Verificación Vehicular</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                El Programa Subsidio al Servicio de Verificación Vehicular busca promover el ejercicio del derecho a un medio ambiente sano mediante el otorgamiento de un subsidio al servicio de verificación vehicular, con el fin de reducir el impacto económico en las personas físicas y personas morales propietarias de vehículos que cumplan con la obligación de verificación vehicular en el Estado de Hidalgo.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Fomentar y proteger el derecho social a un medio ambiente sano, así como contribuir al saneamiento ambiental y a la mitigación del cambio climático, mediante la implementación de un subsidio del 50% al pago del servicio de verificación vehicular, dirigido a las personas propietarias, poseedoras o conductoras de vehículos automotores matriculados en el Estado de Hidalgo, con el propósito de incentivar el cumplimiento de la verificación vehicular y fortalecer el control de emisiones contaminantes provenientes de fuentes móviles.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                La población objetivo del Programa comprende a personas físicas o morales del sector privado, propietarias, poseedoras o conductoras de vehículos de combustión interna matriculados en el Estado de Hidalgo, destinados al transporte público y privado, al concentrar las principales fuentes móviles de emisiones contaminantes. Su atención permite mejorar la calidad del aire y, desde un enfoque socioeconómico, mitigar cargas económicas de quienes dependen del uso vehicular.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                La cobertura del programa es en todo el territorio del Estado de Hidalgo, conforme a la suficiencia presupuestal y Financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Ejercicio fiscal 2026
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                <ul>
                <li><b>Centros de Verificación Vehicular</b></li>
                <li><b>Dirección del Subsidio al Servicio de Verificación Vehicular</b></li>
                <dd>Francisco Maldonado lecona #103, Ampliación Santa Julia, antigua carretera México-Pachuca.</dd>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Manuel Alejandro Hernández Rivera
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                N/A
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Horario de atención</h5>
                <p>
                Lunes a Viernes de 9:30 a 17:00 hrs
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROPs_Programa_Subsidio_al_Servicio_de_Verificacion_Vehicular_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                </ul>
               

              
                </p>
                
              </div>
            </div>
            
          </div>
        </div>

      </div>    
    </div>
  );
};

export default SubsidioVerificacion;